<template>
  <div>
    <div class="row">
      <div class="col-12">
        <card class="custom-shadow-card-header">
          <el-collapse v-model="activeName" @change="handleCollapse">
            <el-collapse-item :title="titleFilter" name="filter">
              <filter-component
                @filter="handleFilter"
                @showHideLoading="showHideLoading"
                :filterOfLots="false"
                :filterOfFarms="false"
              >
                <template slot="prev">
                  <select-component
                    class="pt-3"
                    :rowClass="`col-12 col-sm-6 col-xl-4`"
                    :labelSelect="`${$t(
                      'boxinspection.inspection_location'
                    )}: `"
                    :dataOptions="locations"
                    :initialSelection="dataFilter.location_ids"
                    @onChange="handleChangeSelected"
                    modelName="location_ids"
                  />

                  <select-component
                    class="pt-3"
                    :rowClass="`col-12 col-sm-6 col-xl-4`"
                    :labelSelect="`${$t('common_words.farms')}: *`"
                    :dataOptions="farms"
                    :requireClass="`required-farm-id`"
                    :initialSelection="dataFilter.farm_ids"
                    @onChange="handleChangeSelected"
                    modelName="farm_ids"
                  />
                </template>
              </filter-component>
            </el-collapse-item>
          </el-collapse>
        </card>

        <!-- Contenido -->
        <div v-if="isIndex()">
          <div class="" v-if="hasData">
            <!-- Indicadores -->
            <card>
              <div class="row mb-2 justify-content-center">
                <div class="col-12 col-md-6 col-lg-3 mb-2">
                  <kpi
                    :label="$t('grow.finished_product_quality')"
                    :value="avgPcmsTotalValue"
                  />
                </div>

                <div
                  class="col-12 col-md-6 col-lg-3 mb-2"
                  v-for="item in farmTargetsKpis"
                  :key="item.label"
                >
                  <kpi
                    :label="item.label"
                    :value="item.value"
                    labelColor="#ff2525"
                  />
                </div>
              </div>
            </card>

            <!-- GRAFICAS -->
            <div class="row">
              <div class="col-12 col-md-12 col-lg-6">
                <card>
                  <div class="row">
                    <div class="col-12">
                      <highcharts :options="chartOptions[3]"></highcharts>
                    </div>
                  </div>
                </card>
              </div>

              <div class="col-12 col-md-12 col-lg-6">
                <card>
                  <div class="row">
                    <div class="col-12">
                      <highcharts :options="chartOptions[1]"></highcharts>
                    </div>
                  </div>
                </card>
              </div>
            </div>
          </div>

          <div class="" v-if="hasData">
            <div class="row">
              <div class="col-12 col-md-12 col-lg-6">
                <card>
                  <div class="row">
                    <div class="col-12">
                      <highcharts :options="chartOptions[2]"></highcharts>
                    </div>
                  </div>
                </card>
              </div>

              <div class="col-12 col-md-12 col-lg-6">
                <card>
                  <div class="row">
                    <div class="col-12">
                      <highcharts :options="chartOptions[4]"></highcharts>
                    </div>
                  </div>
                </card>
              </div>
            </div>
          </div>

          <div class="" v-if="hasData">
            <div class="col-12 col-md-12 col-lg-12">
              <card>
                <div class="row">
                  <div class="col-12">
                    <highcharts :options="chartOptions[0]"></highcharts>
                  </div>
                </div>
              </card>
            </div>
          </div>

          <!-- TABLA -->
          <card v-if="tableData.length > 0">
            <card-header
              :propPagination="pagination"
              @searchedQuery="handleSearchQuery"
              class="mr-3 mt-4"
            />
            <master-table
              :infoTable="queriedData"
              :columns="tableColumns"
              :showColumnStatus="false"
            >
              <template slot="addColumns">
                <el-table-column
                  prop="defects"
                  :label="$t('production.defects')"
                  width="100"
                  :align="'left'"
                  type="expand"
                >
                  <template slot-scope="scope">
                    <div v-if="scope.row.defects && scope.row.defects.length">
                      <template
                        v-for="(group, category) in groupDefects(
                          scope.row.defects
                        )"
                      >
                        <div style="margin-bottom: 6px">
                          <strong>{{ category }}:</strong>
                          <div
                            v-for="(item, index) in group"
                            :key="index"
                            style="margin-left: 10px"
                          >
                            - {{ item.defect }} ({{ item.clusters }})
                          </div>
                        </div>
                      </template>
                    </div>
                    <span v-else>-</span>
                  </template>
                </el-table-column>
              </template>
            </master-table>

            <card-footer ref="cardfooter" :propPagination="pagination" />

            <export-tables
              :pdf="{
                filename: '',
                route: '',
                showPDFButton: false,
              }"
              :xls="{
                filename: `${$t('grow.finished_product_quality')}_${
                  dataFilter.date_from
                }_${dataFilter.date_to}.xlsx`,
                route: 'grow/finishedproduct/detailed/excel',
                paramMethod: 'POST',
                plusData: { ...getDataToExport },
              }"
            />
            <br />
          </card>
        </div>
        <not-index-permissions v-else />
      </div>
    </div>
  </div>
</template>

<script>
import { Axios } from 'src/class/Axios.js';
import { isset } from 'src/util/Util.js';
import { Chart } from 'highcharts-vue';
import Highcharts from 'highcharts';
import drilldown from 'highcharts/modules/drilldown';
import exportingInit from 'highcharts/modules/exporting';
import Filter from 'src/components/Filter/Filters.vue';
import Formatter from 'src/class/Formatter.js';
import configTable from './finished-product-quality-table';
import Kpi from 'src/views/Layouts/Kpi.vue';
import i18n from 'src/i18n';
import MixinCharts from 'src/util/mixinCharts';
import { MixinExport } from 'src/mixins/mixin-export';
import MixinMenu from 'src/util/mixinMenu';
import mixinMasters from 'src/util/mixinMasters';
import MixinPermissions from 'src/util/mixinPermissions';
import { MixinNotification } from 'src/mixins/mixin-notification';
import MixinValidations from 'src/mixins/forms/mixin-validations';
import SweetAlert from 'src/class/Alerts';
import moment from 'moment';

drilldown(Highcharts);
exportingInit(Highcharts);

export default {
  name: 'FinishedProductQuality',

  components: {
    [Filter.name]: Filter,
    highcharts: Chart,
    [Kpi.name]: Kpi,
  },

  data() {
    return {
      dataFilter: {
        farm_ids: null,
        location_ids: null,
        date_from: moment().subtract(1, 'year').format('YYYY-MM-DD'),
        date_to: moment().format('YYYY-MM-DD'),
        date_sel: null,
      },

      activeName: 'filter',
      valueCollapse: null,

      farms: [],
      locations: [],

      tableData: [],
      tableColumns: [],
      searchQuery: '',
      fuseSearch: null,
      pagination: {},

      // [0]=Defects, [1]=Quality, [2]=Supervisor, [3]=Time, [4]=Worker(Operator)
      chartOptions: [{}, {}, {}, {}, {}],

      hasData: false,
      indicators: {
        avg_pcms_total: 0,
        targets_by_farm: [],
      },
    };
  },

  computed: {
    ...configTable().Search,

    titleFilter() {
      if (this.valueCollapse) {
        return this.valueCollapse.length === 1
          ? this.$i18n.t('uti.mixinFilter.hideFilters')
          : this.$i18n.t('uti.mixinFilter.showFilters');
      }

      return this.$i18n.t('uti.mixinFilter.hideFilters');
    },
    getDataToExport() {
      const response = {
        data: this.tableData,
        date_sel: this.dataFilter.date_sel,
      };
      delete response.route;

      return response;
    },
    periodLabel() {
      switch (this.dataFilter.date_sel) {
        case 'Día':
          return this.$t('common_words.day');
        case 'Semana':
          return this.$t('common_words.week');
        case 'Mes':
          return this.$t('common_words.month');
        case 'Año':
          return this.$t('common_words.year');
        default:
          return this.$t('common_words.day');
      }
    },

    avgPcmsTotalValue() {
      return `${this.indicators.avg_pcms_total || 0}%`;
    },

    farmTargetsKpis() {
      return (this.indicators.targets_by_farm || []).map((item) => {
        return {
          label: `${this.$t('grow.goal')}: ${item.business}`,
          value: `${item.target}%`,
        };
      });
    },
  },

  mixins: [
    MixinPermissions,
    mixinMasters,
    MixinNotification,
    MixinValidations,
    MixinCharts,
    MixinExport,
    MixinMenu,
  ],

  watch: {
    '$i18n.locale': 'setupTable',
    'dataFilter.date_sel': 'setupTable',
  },

  methods: {
    groupDefects(defects) {
      return defects.reduce((acc, d) => {
        const cat = d.category || 'Sin categoría';

        if (!acc[cat]) {
          acc[cat] = [];
        }

        acc[cat].push(d);
        return acc;
      }, {});
    },

    handleCollapse(val) {
      this.valueCollapse = val;
    },

    handleSearchQuery(query) {
      this.searchQuery = query;
    },

    handleChangeSelected(data) {
      this.$set(this.dataFilter, data.name, data.selects);
      this.tableData = [];
      this.indicators = {
        avg_pcms_total: 0,
        targets_by_farm: [],
      };
      this.hasData = false;
      this.$set(this.chartOptions, 0, {});
      this.$set(this.chartOptions, 1, {});
      this.$set(this.chartOptions, 2, {});
      this.$set(this.chartOptions, 3, {});
      this.$set(this.chartOptions, 4, {});
    },

    setupTable() {
      const { Table } = configTable();
      this.tableColumns = Table.tableColumns;
      this.pagination = { ...Table.pagination };
      this.pagination.perPage = 10;
      this.pagination.currentPage = 1;
    },

    // Funcion para filtrar
    handleFilter(data) {
      this.tableData = [];
      this.hasData = false;
      this.indicators = {
        avg_pcms_total: 0,
        targets_by_farm: [],
      };
      this.$set(this.chartOptions, 0, {});
      this.$set(this.chartOptions, 1, {});
      this.$set(this.chartOptions, 2, {});
      this.$set(this.chartOptions, 3, {});
      this.$set(this.chartOptions, 4, {});

      this.dataFilter = {
        ...this.dataFilter,
        date_from: data.datei,
        date_to: data.datef,
        date_sel: data.bySel,
      };

      if (!isset(this.dataFilter.farm_ids)) {
        return this.validationInputsRequired('farm-id');
      }

      this.getData();
    },

    getData() {
      this.showHideLoading(true);

      let payload = {
        ...this.dataFilter,
        route: 'grow/finishedproduct/filter',
      };

      if (payload.date_sel === 'Año') {
        payload.date_from += '-01-01';
        payload.date_to += '-12-31';
      }

      Axios.postMasters(payload)
        .then((response) => {
          const res = response.data.data || {};
          this.tableData = res.table || [];
          this.indicators = res.indicators || {
            avg_pcms_total: 0,
            targets_by_farm: [],
          };
          this.hasData = this.tableData.length > 0;

          if (!this.hasData) {
            SweetAlert.warning(i18n.t('common_words.unavailable_data'));
            this.showHideLoading();
            return;
          }

          // Charts
          this.loadChartsFromBackend(res);

          // Search (filtro tabla)
          try {
            this.searchFuse(
              this.tableColumns.map((c) => c.prop),
              null,
              0.3
            );
          } catch (error) {
            console.log(error);
          }

          this.showHideLoading();
        })
        .catch((error) => {
          this.showHideLoading();
          SweetAlert.warning(error.response.data.message || 'Error');
        });
    },

    // Funcion que cargar la data del backend para graficarla
    loadChartsFromBackend(res) {
      const defectsPayload =
        res.charts && res.charts.defects
          ? res.charts.defects
          : { series: [], drilldown: [] };

      const qualityPayload =
        res.charts && res.charts.quality
          ? res.charts.quality
          : { series: [], drilldown: [] };

      const qualitySupervisorPayload =
        res.charts && res.charts.quality_supervisor
          ? res.charts.quality_supervisor
          : { series: [], drilldown: [] };

      const timePayload =
        res.charts && res.charts.quality_time
          ? res.charts.quality_time
          : { series: [], drilldown: [] };

      const qualityWorkerPayload =
        res.charts && res.charts.quality_worker
          ? res.charts.quality_worker
          : { series: [], drilldown: [] };

      let options0 = this.columns(defectsPayload, true);
      let options1 = this.columns(qualityPayload, true);
      let options2 = this.columns(qualitySupervisorPayload, true);
      let options3 = this.lines(timePayload, true, 'auto', false, true);
      let options4 = this.columns(qualityWorkerPayload, true);

      // Botón a la derecha
      const drillUpConfig = {
        drillUpButton: {
          position: {
            align: 'right',
            x: -3,
            y: -25,
          },
        },
      };

      options0.drilldown = { ...options0.drilldown };
      options1.drilldown = { ...options1.drilldown, ...drillUpConfig };
      options2.drilldown = { ...options2.drilldown, ...drillUpConfig };
      options4.drilldown = { ...options4.drilldown, ...drillUpConfig };

      this.$set(this.chartOptions, 0, options0);
      this.$set(this.chartOptions, 1, options1);
      this.$set(this.chartOptions, 2, options2);
      this.$set(this.chartOptions, 3, options3);
      this.$set(this.chartOptions, 4, options4);

      const drillText = {
        drillUpText: `${i18n.t('common_words.return_to')} {series.name}`,
      };
      this.chartOptions[0].lang = drillText;
      this.chartOptions[1].lang = drillText;
      this.chartOptions[2].lang = drillText;
      this.chartOptions[4].lang = drillText;
    },
  },

  created() {
    if (this.isIndex()) {
      this.showHideLoading(true);
      this.setupTable();

      Promise.all([
        Axios.getMasters('farms/farms/only'),
        Axios.getMasters('quality/locationinspections'),
      ])
        .then(([responseFarm, responseLocation]) => {
          this.farms = this.concatAll(responseFarm.data.data);
          this.locations = this.concatAll(responseLocation.data.data);
          this.searchQuery = '';

          this.showHideLoading();
        })
        .catch((error) => {
          this.showHideLoading();
          this.showMessageErrors(error);
        });
    } else {
      this.showHideLoading();
    }
  },

  mounted() {
    this.selectedItemOnMenu('lossreport');
  },

  destroyed() {
    this.deselectedItemOnMenu('lossreport');
  },
};
</script>
